export default __webpack_public_path__ + "static/media/thumb-slider.1630c2c7.png";